import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TokenFormatEnum } from 'v3/shared/constants/token-type.enum';
import { tokenInitialState } from './state';

export const tokenSlice = createSlice({
  name: 'token',
  initialState: tokenInitialState,
  reducers: {
    setToken: (state, action: PayloadAction<string>) => {
      state.code = action.payload;
      return state;
    },
    setSelectedOption: (state, action: PayloadAction<TokenFormatEnum>) => {
      state.selectedOption = action.payload;
      return state;
    },
    setCanSendToken: (state, action: PayloadAction<boolean>) => {
      state.canSendToken = action.payload;
      return state;
    },
    setEnablePreContractDownload: (state, action: PayloadAction<boolean>) => {
      state.flagSelectForPreContract = action.payload;
      return state;
    },
  },
});
